







import { Vue, Component } from "vue-property-decorator";
import tasks from "@/store/modules/tasks";
import Wrapper from "@/components/Wrapper.vue";

@Component({ components: { Wrapper } })
export default class App extends Vue {
  created() {
    tasks.getTasksFromLocalStorage();
  }
}
